const article1 = {
  "id": "for-you-1",
  "imageUrl": "https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/homepage/images/2025/November/Inspiration-hub290x245.jpg",
  "title": "Travel Guides & Inspiration",
  "body": "Get inspired by exploring our expert travel guides, itineraries, and curated hotels. Plus, learn about the elevated benefits that eligible Cardmembers can enjoy when booking through American Express Travel.",
  "ctaLabel": "Get inspired",
  "ctaDestination": "https://www.americanexpress.com/en-gb/travel/inspiration/"
};
const article2 = {
  "id": "for-you-2",
  "attribution": "Fine Hotels + Resorts",
  "imageUrl": "https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/homepage/images/2026/February/CollegioallaQuerce.jpg",
  "title": "Fine Hotels + Resorts",
  "body": "Platinum Cardmembers receive a complimentary suite of benefits, including daily breakfast for two and guaranteed 4pm check-out, with Fine Hotels + Resorts stays booked through American Express Travel.",
  "ctaLabel": "Explore Fine Hotels + Resorts",
  "ctaDestination": "https://hotel-booking.americanexpress.com/en-gb/fhr/welcome"
};
const article3 = {
  "id": "for-you-3",
  "imageUrl": "https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/homepage/images/2026/January/Hiltonoffers.jpg",
  "title": "Pay With Points",
  "body": "At American Express Travel, eligible Cardmembers can use Membership Rewards® points for all or part of your flight, prepaid hotel, prepaid car rental or holiday bundle. Terms apply.",
  "ctaLabel": "Pay With Points",
  "ctaDestination": "https://www.americanexpress.com/uk/travel/how-to-pay-with-points/"
};
const article4 = {
  "id": "for-you-4",
  "attribution": "Grand Hotel Son Net",
  "imageUrl": "https://icm.aexp-static.com/Internet/travel/cttonline/en_US/homepage/2026/April/GuestTile1.jpg",
  "title": "Preferred Hotels & Resorts",
  "body": "Enjoy a curated selection of luxurious getaways with world‑class service, and award‑winning dining in sought‑after destinations around the globe.",
  "ctaLabel": "Explore Hotels",
  "ctaDestination": "https://hotel-booking.americanexpress.com/en-gb/fhr/welcome"
};
const ad = {
  "id": "for-you-ad",
  "channelName": "TLS",
  "placementName": "HOMEPAGE_FORYOU",
  "placementId": "TravelWeb_Homepage_ForYou_Tile_3",
};

export const mockHeading = 'Personalized Marketing Articles';

export const mockArticleSets = {
  'Four Articles': [article1, article2, article3, article4],
  'Three Articles': [article1, article2, article3],
  'Two Articles': [article1, article2],
  'One Article': [article1],
  'Three Articles with Ad': [article1, article2, ad, article4],
  'Two Articles with Ad': [article1, article2, ad],
  'One Article with Ad': [article2, ad],
  'Ad Only': [ad],
  'With CTA button': [
    {...article1, showCtaButton: true},
    {...article2, showCtaButton: true},
    {...article3, showCtaButton: true},
    {...article4, showCtaButton: true},
  ],
  'With no CTA text': [
    {...article1, ctaLabel: undefined},
    {...article2, ctaLabel: undefined},
    {...article3, ctaLabel: undefined},
    {...article4, ctaLabel: undefined},
  ],
};
